<!-- IIT2-1438-start -->
<div *ngIf='!isViewOpen || !attractViewOn' class="fade show partner_content" id="approvePartnerContentTab">
  <div class="d-flex flex-column h-100">
    <!-- Data heading and info -->
    <div class="data_header" id="partnerDataHeader">
      <div class="results_info mb-3" id="resultInfoPartnerCon">
        <div class="title" id="titlePartnerCon"><span i18n = "@@approved-partner-content.title.approved-content">Approved Content</span></div>
        <div class="results" *ngIf='isPartnerTabActive; else resultElse' id="resultsPartnerCon">
          <span i18n="@@approved-partner-content.pagination.showing">Showing <strong>{{ showFrom }} - {{ showTo }} </strong> of <strong> {{ paginationCount }} Partner Content
            Groups</strong></span>
        </div>
        <ng-template #resultElse>
          <div class="results" id="partnerConAttractLoop">
            <span i18n="@@approved-partner-content.pagination.showing-attract">Showing <strong>{{ showFromAttr }} - {{ showToAttr }}</strong> of <strong>{{ attractLoop?.length }} Attract Loop Videos</strong></span>
          </div>
        </ng-template>
      </div>
      <div ngbDropdown class="dropdown" container="body" *ngIf='partner?.length' id="approvedDropDown">
        <button class="btn btn-primary dropdown-toggle" id='approveDropdown' type="button"
          ngbDropdownToggle>
          {{selectedButton}}
        </button>
        <div ngbDropdownMenu aria-labelledby="approveDropdown" class="dropdown-menu" id="dropDownData">
          <ng-container *ngFor="let data of partner,let i = index">
            <ng-container *ngIf="partnerLabel !== data">
              <button (click)='selectedPartner(data, partnerID[i])' class="dropdown-item">{{data}}</button>
            </ng-container>
          </ng-container>
        </div>
      </div> 
    </div>
    <!-- IJR-2051 -->
    <div class="mt-3 mb-3 d-flex" id="containerTabChange">
      <ng-container *ngIf = 'pID'>
        <div class="tab" (click) = "tabChange()" [ngClass]="{'active-tab':isPartnerTabActive ,'inactive-tab':!isPartnerTabActive}"><span i18n = "@@approved-partner-content.tab-switch.partner-content">Partner Content</span></div>
        <div class="tab" (click) = "tabChange()" [ngClass]="{'active-tab':!isPartnerTabActive ,'inactive-tab':isPartnerTabActive}"><span i18n = "@@approved-partner-content.tab-switch.attract-loop">Attract Loop Videos</span></div>
      </ng-container>
      
      
      <div class="tab-container" id="tabContainer"></div>
    </div>
    <div class="text-center" [ngClass]="isPartnerEmpty ? 'existing_text_show': 'existing_text_hide'" id="noPartnerConAttractLoop">
      <span i18n = "@@approved-partner-content.heading.no-partner-content">There is no Partner Content/Attract Loop approved</span>
    </div>

    <div class="text-center" *ngIf='!spinnerStatus' [ngClass]="selectedButton === 'Select Partner' && !isPartnerEmpty ? 'existing_text_show': 'existing_text_hide'" id="partnerContentApproved">
      <span i18n = "@@approved-partner-content.heading.view-approved-content">Please select a partner to view the
        approved content</span>
    </div>

    <div class="text-center" *ngIf='noData && isPartnerTabActive' id="noApprovPartnerCon">
      <span i18n = "@@approved-partner-content.heading.none-approved-content">No Approved Partner Content</span>
    </div>
    <div class="text-center" *ngIf='noAttractLoop && !isPartnerTabActive' id="noApprovAttrctLoopVideo">
      <span i18n = "@@approved-partner-content.heading.no-approved-attract-video">No Approved Attract Loop Video</span>
    </div>
    <div class="text-center" *ngIf='noAttractLoop && noData' id="noData">
      <span i18n = "@@approved-partner-content.heading.no-partner-content-approved">There is no Partner Content/Attract Loop approved</span>
    </div>

    <!-- Table data -->
    <iposcen-spinner-overlay (getStatus) = "spinnerStatus = $event"></iposcen-spinner-overlay>
    <!-- PC Table Data -->
    <div *ngIf='selectedButton !== "Select Partner"' id="pcTblData">

      <div class="table-responsive" *ngIf='isPartnerTabActive; else tableElse' id="pcTblDataRes">
        <div *ngIf = "contents?.length" id="pcTblDataCon">
        <table id="reviewPartnersTable" class="table table-borderless" [ngClass]="{'remove-margin':isNoneSelected}"
          aria-describedby="approvedPartners">
          <thead>
            <tr>
              <th scope="col">
                <span class="table_headings">
                  <span i18n = "@@approved-partner-content.table-heading.content-name">Content Name</span>
                  <span class="chevron_expand" (click)="sort('contentName')"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n = "@@approved-partner-content.table-heading.language-category">Language Category</span>
                  <span class="chevron_expand" (click)="sort('languageCategory')"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n = "@@approved-partner-content.table-heading.system-id">System ID</span>
                  <span class="chevron_expand" (click)="sort('systemID')"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n = "@@approved-partner-content.table-heading.created-by">Created By</span>
                  <span class="chevron_expand" (click)="sort('createdByName')"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n = "@@approved-partner-content.table-heading.last-updated">Last Updated</span>
                  <span class="chevron_expand" (click)="sort('updatedTime')"></span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Row 1 -->
            <ng-container *ngFor="let data of contents, let i = index">
              <tr>
                <td>{{data.contentName}}</td>
                <td>{{data.languageCategory}}</td>
                <td>{{data.systemID}}</td>
                <td>{{data.createdByName}}</td>
                <td>{{data.updatedTime | dateFormat:'changeToLocalTimeZone'}}</td>
                <td class="view_cell">
                  <span class="modify_record">
                    <button (click)='openConfirmationContentGroupPopup(data?.contentName, data?.contentID)' class="btn btn-link btn-teritiary left_icon_btn">
                      <img class="push_content_icon" alt="push content" />
                      <span>Push content</span>
                    </button>
                  </span>
                </td>
                <td class="view_cell">
                  <span class="modify_record">
                    <button (click)='openView(data.contentID, data.autoID)' class="btn btn-link btn-teritiary left_icon_btn">
                      <img class="view_icon" alt="view" />
                      <span i18n ="@@create-partner-content.table-data.view">View</span>
                    </button>
                  </span>
                </td>
              </tr>
            </ng-container>
          </tbody>

        </table>
        </div>
      </div>
<!-- ATV Table Data -->
<ng-template #tableElse>
  <div class="table-responsive" *ngIf= "!noAttractLoop" id="tblDataATV">
    <table id="atrtactloopVideoTable" class="table table-borderless" [ngClass]="{'remove-margin':isNoneSelected}"
      aria-describedby="approvedatrtactLoopVideo">
      <thead>
        <tr>
          <th scope="col">
            <span class="table_headings">
              <span i18n = "@@global.search.name">Name</span>
              <span class="chevron_expand" (click)="sort('attractLoopName')"></span>
            </span>
          </th>
          <th scope="col">
            <span class="table_headings">
              <span i18n="@@global.search.location">Location</span>
            </span>
          </th>
          <th scope="col">
            <span class="table_headings">
              <span i18n = "@@partners.last-updated.last-updated">Last Updated</span>
              <span class="chevron_expand" (click)="sort('updatedTime')"></span>
            </span>
          </th>
          <th scope="col">
            <span class="table_headings">
              <span i18n = "@@create-partner-content.tableheader.lastupdatedby">Last Updated By</span>
              <span class="chevron_expand" (click)="sort('updatedByName')"></span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Row 1 -->
        <ng-container *ngFor="let data of attractLoop, let i = index">
          <tr>
            <td>{{data.attractLoopName}}</td>
            <td>
              <span *ngIf="data?.parsedLocations?.length == 1">
                {{data.parsedLocations[0] | translateLocation}}
              </span>
              <span *ngIf="data?.parsedLocations?.length > 1 && data?.parsedLocations?.length < 66">
                {{data.parsedLocations[0] | translateLocation}} 
                <span class="popup-badge" [ngbPopover]='locationPopUp'
                  [popoverTitle]="data.parsedLocations.length + ' Locations'" placement="right">
                  +{{data.parsedLocations.length - 1}}
                </span>
              </span>
              <span *ngIf="data?.parsedLocations?.length >= 66">
                All Locations
              </span>
            </td>
            <ng-template #locationPopUp>
              <div id="locationPopupList">
                <div id="locationMap"
                  [ngClass]="{'popup-size-scroll': data?.parsedLocations.length > 5, 'popup-size': data?.parsedLocations.length <= 5}">
                  <ul class='reduceLeftPad'>
                    <li class="child" *ngFor='let location of data?.parsedLocations'>{{location | translateLocation}}</li>
                  </ul>
                </div>
              </div>
            </ng-template> 
            <td>{{data.updatedTime | dateFormat:'changeToLocalTimeZone'}}</td>
            <td>{{data.updatedByName}}</td>
            <td class="view_cell">
              <span class="modify_record">
                <button (click)='openConfirmationAttractPopupModal(data.attractLoopName, data.attractLoopId)' class="btn btn-link btn-teritiary left_icon_btn">
                  <img class="push_content_icon" alt="push content" />
                  <span>Push content</span>
                </button>
              </span>
            </td>
            <td class="view_cell">
              <span class="modify_record">
                <button (click)='openAttrView(data.attractLoopId)' class="btn btn-link btn-teritiary left_icon_btn">
                  <img class="view_icon" alt="view" />
                  <span i18n = "@@create-partner-content.table-data.view">View</span> 
                </button>
              </span>
            </td>
          </tr>
        </ng-container>
      </tbody>

    </table>
  </div>
</ng-template>
      


    </div>
    <hr *ngIf='selectedButton !== "Select Partner" && partner?.length' [ngClass]="{'remove-margin-top':isNoneSelected}" />

    <!-- Pagination -->
    <div class="data_footer position-relative" *ngIf="selectedButton !== 'Select Partner' && partner?.length">
      <div class="d-flex flex-column align-items-center" *ngIf='isPartnerTabActive; else pageElse'>
        <div *ngIf = "contents?.length">
          <div class="pagCenter">

            <nav aria-label="content pagination">
              <ngb-pagination [collectionSize]="paginationCount" [(page)]="page" [pageSize]="tableSize" [rotate]="false"
              [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false" (pageChange)="onTableDataChange($event)">
              </ngb-pagination>
            </nav>
          </div>
          <div class="results mt-2">
          <span i18n="@@approved-partner-content.pagination.showing">Showing <strong>{{ showFrom }} - {{ showTo }} </strong> of <strong> {{ paginationCount }} Partner Content
            Groups</strong></span>
          </div>
        </div>
      </div>
      <ng-template #pageElse>
        <div class="d-flex flex-column align-items-center" *ngIf = "!noAttractLoop">
          <nav aria-label="content pagination">
            <ngb-pagination [collectionSize]="attractLoop?.length" [(page)]="pageAttr" [pageSize]="tableSize" [rotate]="false"
              [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false" (pageChange)="onTableDataChange($event)">
            </ngb-pagination>
          </nav>
          <div class="results mt-2">
            <span i18n="@@approved-partner-content.pagination.showing-attract">Showing <strong>{{ showFromAttr }} - {{ showToAttr }}</strong> of <strong>{{ attractLoop?.length }} Attract Loop Videos</strong></span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<!-- IJR-2051 END -->
<!-- Adding Confirmation popup before push updates. -->
<!-- IIT3-32 -->
<div class="container">
  <div class="modal-dialog modal-dialog-centered" *ngIf="openConfirmationContentPopup || openConfirmationAttractPopup">
    <div class="modal-backdrop show"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="close" data-dismiss="modal" (click)="closeModal()">
            <img class="modal-close-icon" alt="close" />
          </div>
          <div class="modal-body popup-modal">
            <div class="heading" *ngIf="openConfirmationContentPopup"><span i18n="@@approved-partner-content.popup-modal.are-you-sure-push">Are you sure you want to push the updates of {{contentsName}}?</span>
            </div>
            <div class="heading" *ngIf="openConfirmationAttractPopup"><span i18n="@@approved-partner-content.popup-modal.are-you-sure-push">Are you sure you want to push the updates of {{attractLoopName}}?</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" (click)="closeModal()" class="btn btn-outline-primary btn-cancel">
              <span i18n="@@showon-device.footer.no">No</span>
            </button>
            <div *ngIf="contentsName">
              <button type="button" class="btn btn-primary btn-confirm" (click)="openPushUpdatesModal(contentsName)">
               <span i18n="@@approved-partner-content.footer.yes">Yes</span>
              </button>
            </div>
            <div *ngIf="attractLoopName">
              <button type="button" class="btn btn-primary btn-confirm" (click)="openPushAttractModal(attractLoopName)">
                <span i18n="@@approved-partner-content.footer.yes">Yes</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- confirmation popup for push updates -->
<div class="container">
  <div class="modal-dialog modal-dialog-centered" *ngIf="openModal">
    <div class="modal-backdrop show"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="close" data-dismiss="modal" (click)="closeModal()">
            <img class="modal-close-icon" alt="close" />
          </div>
          <div class="modal-body popup-modal">
            <img class="check_circle" alt="check circle" />
            <div class="heading" *ngIf="contentsName"><span i18n="@@approved-partner-content.heading.is-pushed">{{contentsName}}
                is pushed</span></div>
            <div class="heading" *ngIf="attractLoopName"><span i18n="@@approved-partner-content.heading.is-pushed">{{attractLoopName}} is pushed</span></div>
            <div class="text-body">
              <span i18n="@@approved-partner-content.text-body.content-pushed-to-one-device" *ngIf="devicesCount === 1">
                <p>Content is pushed to {{devicesCount}} device. These changes will reflect on device with an active internet connection.</p>
              </span>            
              <span i18n="@@approved-partner-content.text-body.content-pushed-to-devices" *ngIf="devicesCount !== 1">
                <p>Content is pushed to {{devicesCount}} devices. These changes will reflect on devices with an active internet connection.</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>